const META_FIELDS = new Set([
  'id',
  'name',
  'slug',
  'arena',
  'image',
  'image_file',
  'player_id',
  'race_name',
])

const TYPE_FIELDS = {
  status: ['status', 'sub_status'],
  visibility: ['visibility'],
  fatigue: ['fatigue'],
  bleeding: ['bleeding'],
  surprise: ['surprised'],
}

const FIELD_LABELS = {
  ca: 'CA',
  cr: 'CR',
  sr: 'SR',
  sr_adj: 'SR Adj',
}

function formatLabel(value = '') {
  const normalizedValue = String(value || '').toLowerCase()

  if (Object.hasOwn(FIELD_LABELS, normalizedValue)) {
    return FIELD_LABELS[normalizedValue]
  }

  return String(value)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())
}

function formatValue(value) {
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }

  if (value === null || value === undefined || value === '') {
    return 'None'
  }

  return formatLabel(value)
}

function getRelevantFields(payload = {}, type = '') {
  const typedFields = TYPE_FIELDS[type] ?? []

  if (typedFields.length > 0) {
    return typedFields.filter((field) => Object.hasOwn(payload, field))
  }

  const payloadFields = Object.keys(payload).filter((field) => !META_FIELDS.has(field))

  return payloadFields.length === 1 ? payloadFields : []
}

function getChangedFields(payload = {}, originalPayload = {}) {
  return Object.keys(payload).filter((field) => {
    if (META_FIELDS.has(field) || !Object.hasOwn(originalPayload, field)) {
      return false
    }

    return payload[field] !== originalPayload[field]
  })
}

export default function formatCombatantUpdateMessage({
  payload = {},
  originalPayload = {},
  combatantName = '',
  type = '',
} = {}) {
  const name = combatantName || payload?.name || 'Combatant'
  const changedFields = getChangedFields(payload, originalPayload)
  const fields = changedFields.length > 0 ? changedFields : getRelevantFields(payload, type)

  if (fields.length === 0) {
    return `${name} updated`
  }

  const detail = fields.map((field) => `${formatLabel(field)} now ${formatValue(payload[field])}`)

  return `${name} updated (${detail.join(', ')})`
}
